import { nanoid } from 'nanoid';

import { WorkflowNodeType } from '../constants';
import { FlowNodeRegistry } from '../../typings';
import iconApi from '../../assets/icon-api.png';
import { formMeta } from './api-call-meta';

const ApiCallNodeRegistry: FlowNodeRegistry = {
  type: WorkflowNodeType.ApiCall,
  label: 'API 调用',
  meta: {},
  info: {
    icon: iconApi,
    description: '执行 API 调用',
  },
  formMeta,
  onAdd(ctx) {
    return {
      id: `${WorkflowNodeType.ApiCall}_${nanoid(5)}`,
      type: WorkflowNodeType.ApiCall,
      data: {
        title: 'API 调用',
      },
    };
  },
};

export { ApiCallNodeRegistry };
